"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _services = require("./logic/services");

var _AppStore = _interopRequireDefault(require("./logic/store/AppStore"));

var _AppToastAlert = _interopRequireDefault(require("./components/elements/AppToastAlert"));

var _LandingScreen = _interopRequireDefault(require("./LandingScreen"));

require("bootstrap/dist/css/bootstrap.css");

require("./styles/main.scss");

require("bootstrap");

require("font-awesome/css/font-awesome.min.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

_reactModal["default"].setAppElement('#root');

var LaunchPadAdmin = /*#__PURE__*/function (_React$Component) {
  _inherits(LaunchPadAdmin, _React$Component);

  function LaunchPadAdmin(props) {
    var _this;

    _classCallCheck(this, LaunchPadAdmin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LaunchPadAdmin).call(this, props));

    _services.OverrideService.storeConfiguration(props.configuration);

    return _this;
  }

  _createClass(LaunchPadAdmin, [{
    key: "render",
    value: function render() {
      // if (!OverrideService.configuration) return null;
      return _react["default"].createElement(_reactRedux.Provider, {
        store: _AppStore["default"]
      }, _react["default"].createElement(_LandingScreen["default"], null), _react["default"].createElement(_AppToastAlert["default"], null));
    }
  }]);

  return LaunchPadAdmin;
}(_react["default"].Component);

exports["default"] = LaunchPadAdmin;